// useErrorToast.ts
import { getErrorMessage } from "@utils/error";
import { message } from "antd";
import { useEffect } from "react";

export function useErrorToast(error) {
  useEffect(() => {
    if (error) {
      message.error(getErrorMessage(error));
    }
  }, [error]);
}
